// src/app/shared/status-utils.ts
import { I18NextPipe } from 'angular-i18next';

/** ContactCentreStatus from backend */
export enum ContactCentreStatus {
  LoggedOff = 0,
  ReadyOrBusy = 1,
  Pause = 2,
}

/** UserStatus from backend (matches your API) */
export enum UserStatus {
  Undefined = -1,
  System = 0,
  LoggedOff = 1,
  Available = 2,
  Allocated = 3,
  State4NotUsed = 4,
  Connected = 5,
  ConsultCall = 6,
  Searching = 7,
  Pause = 8,
  Busy = 9,
  NoAnswer = 10,
  WrapUp = 11,
  LoggedOffAndSearching = 12,
  LoggedOffAndAllocated = 13,
  LoggedOffAndAlerting = 14,
  LoggedOffAndConnected = 15,
  LoggedOffAndConsultCall = 16,
  PauseAndSearching = 17,
  PauseAndAllocated = 18,
  PauseAndAlerting = 19,
  PauseAndConnected = 20,
  PauseAndConsultCall = 21,
  Setup = 41,
  Alerting = 42,
  LoggedOffAndSetup = 44,
  PauseAndSetup = 45,
  Failure = 50
}

/** Map a backend pair (ccs, userStatus) to a realtime.json key */
export function statusKey(ccs?: number | null, userStatus?: number | null): string {
  if (ccs === ContactCentreStatus.Pause) return 'realtime:status_pause';
  if (ccs === ContactCentreStatus.LoggedOff) return 'realtime:status_loggedOff';

  switch (userStatus as UserStatus) {
    case UserStatus.Available: return 'realtime:status_available';
    case UserStatus.Busy:      return 'realtime:status_busy';
    case UserStatus.Connected: return 'realtime:status_connected';
    case UserStatus.WrapUp:    return 'realtime:status_wrapUp';
    case UserStatus.NoAnswer:  return 'realtime:status_noAnswer';
    case UserStatus.Allocated: return 'realtime:status_connecting';
    case UserStatus.Pause:     return 'realtime:status_pause';
    case UserStatus.LoggedOff: return 'realtime:status_loggedOff'
    default:                   return'NotFound';
  }
}

/** Translate + optionally append a count in parentheses. */
export function translateStatus(
  i18n: I18NextPipe,
  ccs?: number | null,
  userStatus?: number | null,
  count?: number | null | undefined
): string {
  const key = statusKey(ccs, userStatus);
  const label = i18n.transform(key);
  const suffix = (typeof count === 'number') ? ` (${count})` : '';
  return `${label}${suffix}`;
}

/** Sort order if you need it elsewhere */
export function statusSortOrder(userStatus?: number | null): number {
  switch (userStatus as UserStatus) {
    case UserStatus.Available: return 10;
    case UserStatus.Connected: return 20;
    case UserStatus.Busy:      return 30;
    case UserStatus.Pause:     return 40;
    case UserStatus.WrapUp:    return 50;
    case UserStatus.NoAnswer:  return 60;
    case UserStatus.LoggedOff: return 70;
    default:                   return 99;
  }
}
